export const FETCH_ASSESSMENTS_REQUEST = 'FETCH_ASSESSMENTS_REQUEST';
export const FETCH_ASSESSMENTS_SUCCESS = 'FETCH_ASSESSMENTS_SUCCESS';
export const FETCH_ASSESSMENTS_FAILURE = 'FETCH_ASSESSMENTS_FAILURE';
export const START_ASSESSMENT_REQUEST = 'START_ASSESSMENT_REQUEST';
export const START_ASSESSMENT_SUCCESS = 'START_ASSESSMENT_SUCCESS';
export const START_ASSESSMENT_FAILURE = 'START_ASSESSMENT_FAILURE';
export const SUBMIT_ASSESSMENT_REQUEST = 'SUBMIT_ASSESSMENT_REQUEST';
export const SUBMIT_ASSESSMENT_SUCCESS = 'SUBMIT_ASSESSMENT_SUCCESS';
export const SUBMIT_ASSESSMENT_FAILURE = 'SUBMIT_ASSESSMENT_FAILURE';
export const UPDATE_ASSESSMENT_ANSWER = 'UPDATE_ASSESSMENT_ANSWER';
export const FETCH_ASSESSMENT_RESULTS_REQUEST = 'FETCH_ASSESSMENT_RESULTS_REQUEST';
export const FETCH_ASSESSMENT_RESULTS_SUCCESS = 'FETCH_ASSESSMENT_RESULTS_SUCCESS';
export const FETCH_ASSESSMENT_RESULTS_FAILURE = 'FETCH_ASSESSMENT_RESULTS_FAILURE';